import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=7184e18e&scoped=true"
import script from "./page-header.ts?vue&type=script&lang=ts&external"
export * from "./page-header.ts?vue&type=script&lang=ts&external"
import style0 from "./page-header.vue?vue&type=style&index=0&id=7184e18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7184e18e",
  null
  
)

export default component.exports